// Font family constants
const fonts = {
  heading: "Crimson Pro, serif",
  body: "Noto Serif JP, serif",
  brush: "TamanegiKaishoGeki",
};

const fontSizes = {
  small: "12px",
  medium: "16px",
  large: "24px",
};

// Color palette
const colors = {
  text: {
    primary: "#FEFEFE",
    secondary: "#AAAAAA",
    warning: "#C32120",
  },
  background: {
    card: "rgba(0, 0, 0, 0.3)",
    dialog: "#121212ff",
  },
  red: "#C32120",
};

const system = {
  fonts: fonts,
  fontSizes: fontSizes,
  colors: colors,
};
export default system;
